<template>
	<div id='shenlist'>
		<div style="padding-top: 1.5rem;position: relative;left: 0s;">
			<a-row v-if='tableData.length' class='main-mybody' style="height:19.5rem">
				<div class='mydivs'>
					<div style="text-align: center;" v-if='tableData.length == 0'>暫無審核記錄</div>
					<div v-for='(item,ind) in tableData'>
						<div class="c" :style="{borderBottom:ind!==tableData.length-1?'1px solid #d9d9d9':'' }">
							<div style="max-width: 60%;">
								<div style="display: inline-block;max-width: 6rem;min-width: 3.5rem;vertical-align: top;">
									<span style='font-weight: 700;'>{{item.position}} </span>　
								</div>
								<!-- white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis; -->
								<div style="display: inline-block;vertical-align: top;margin-right: .2rem;"> : </div>
								<div style="display: inline-block;max-width: 80%;" v-if='item.remark'>
		{{ item.remark }}
		</div>

							</div>
							<!--  style="color: #3bc7a1;"  style='color: #ed4853;'-->
							<!-- <span v-if='item.status == 0'>審核通過</span>
									<span v-else-if='item.status == 1'>審核拒絕</span>
									<span v-else-if='item.status == 2'>取消開戶</span> -->
							<!-- </div> -->
							<div style="display: flex;justify-content: space-between;">
								<div style="margin-right: .8rem;">{{ item.realname }}</div>
								<div>{{ item.auditDate }}</div>
							</div>
						</div>
						<!-- <div class='t' v-if='ind !== tableData.length'></div> -->
					</div>
					<!-- <div class="c" v-if='item.remark'>{{ item.remark }}</div> -->
					<!-- <div class='t' v-if='ind !== tableData.length-1'></div> -->
				</div>
			</a-row>
		</div>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	export default {
		props: ['record', 'form', 'forms'],
		data() {
			return {
				tableData: [],
				aaa:[
				{remark: "隐藏"},
				{remark: "取消"},
				{remark: "隐藏"},
				{remark: "隐藏"},
				],
			}
		},
		mounted() {
			console.log(this.record,"查看");
			this.getdata()
		},
		methods: {
			getdata(record = this.record) {
				let _this = this;
				let json = {
					token: _this.$store.state.token,
				}
				https.fetchPost(apiUrl.getAdminRemarks, {
					admintype: _this.forms.admintype,
					token: json.token,
					id: record.pdfcode
				}, json).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						this.tableData = data.remarks
						if (this.record.khtype == "郵遞開戶"){
							// this.tableData.splice(0, 2);
							this.tableData = this.tableData.filter(item => item.remark !== "隐藏");
						}
						if (this.record.khtype == "取消開戶"){
							this.tableData = this.tableData.filter(item => item.remark !== "隐藏");
						}
					} else {
						this.$message.warning(data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},

		}
	}
</script>

<style lang='scss' scoped>
	#shenlist {
		.mydivs {
			/* padding: 1rem; */
			/* margin-left: 3%; */
			/* margin: 0 auto; */
			
			/* width: 96%; */
			padding: 0 1rem;
			background-color: #f5f5f5;
			margin-bottom: 1rem;

			.c {
				/* border-bottom: 1px solid #d9d9d9; */
				padding: .9rem 0;
				font-size: 0.835rem;
				/* margin-bottom: .8rem; */
				align-items: flex-start;
				display: flex;
				justify-content: space-between;
			}

			/* .t {
				margin: .5rem 0;
				border-top: 1px solid #d9d9d9;
			}
			 */
		}
		
		/* .mydivs .c:last-child {
			border-bottom: 1px solid #d9d9d9;
		} */
		/* .mydivs:last-child {
			border-bottom: 1px solid #d9d9d9;
		} */
	}
</style>
